import React from 'react'
import { AccordionCard } from 'components/AccordionCard'
import { usePositionDetailContextValue } from '../../context/PositionDetailProvider'
import { PendingApprovalsProvider } from './context/PendingApprovalsProvider'
import { PendingApprovalsMain } from './components/PendingApprovalsMain'

export const PendingApprovals = () => {
  const {
    state: { id: positionId, requirements },
  } = usePositionDetailContextValue()

  const hasAssessmentRequirement = requirements.some(
    (requirement) => requirement.verificationType === 'assessment'
  )

  if (!hasAssessmentRequirement) {
    return null
  }

  return (
    <AccordionCard
      title="Pending Approvals"
      size="large"
      contentWrapperProps={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <PendingApprovalsProvider positionId={positionId}>
        <PendingApprovalsMain />
      </PendingApprovalsProvider>
    </AccordionCard>
  )
}
